import Button from 'components/Button';
import metamaskLogo from 'assets/metamask.png';
import { useMetamask } from 'contexts/Metamask';
import classes from './ConnectMetamask.module.scss';

export default function ConnectMetamask() {
  const { connect } = useMetamask();

  return (
    <div className={classes.root}>
      <div className={classes.overlay}>
        <img src={metamaskLogo} alt="Metamask Logo" style={{height:"129px"}}/>
        <p className={classes.text}>Metamask Connection Required</p>
        <Button className={classes.button} text="Connect Wallet" onClick={connect} />
      </div>
    </div>
  );
}
